const ACCOUNT_SUBTYPE = {
	CHECKING: 'checking',
	SAVINGS: 'savings',
};

export default ACCOUNT_SUBTYPE;
